module.exports = "<div *ngIf=\"AutoLogOutMessage\" class=\"text-center\">\r\n  <h3>{{AutoLogOutMessage}}</h3>\r\n  <button type=\"button\" target=\"_blank\" id=\"btnContinueSession\" class=\"btn btn-shopping mb-2 mt-4 text-center\" (click)=\"OnContinueSessionClick($event)\">Continue Session\r\n  </button>"


//////////////////
// WEBPACK FOOTER
// ./src/app/shoppingcart/auto-log-out-dialog/auto-log-out-dialog.component.html
// module id = ./src/app/shoppingcart/auto-log-out-dialog/auto-log-out-dialog.component.html
// module chunks = main